import React, { ReactNode } from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import isTouchDevice from 'is-touch-device';

type Props = {
  children: ReactNode;
};
const Provider = DndProvider as any; // @todo update react-dnd
export const ReactDndProvider = (props: Props) => {
  const isTouch = isTouchDevice();
  return (
    <Provider backend={isTouch ? TouchBackend : HTML5Backend}>
      {props.children}
    </Provider>
  );
};
